import React from "react";
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import Shape from '../images/Shape.png';
import Rectangle from '../images/Rectangle.png';
import RectangleBlue from '../images/RectangleBlue.png';
import Profile from '../images/Profile.png';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import RectangleGrey from '../images/RectangleGrey.png';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PersonaliseBG from '../images/personaliseBG.png';
import IQOSWHITE from '../images/IQOS-white.png';
import IQOSBLACK from '../images/IQOS-black.png';
import IQOSCOPPER from '../images/IQOS-copper.png';
import IQOSUSAGE from '../images/IQOS-usage.png';
import IQOSMyDevice from '../images/IQOS-mydevice.png';
import TopBar from '../images/topBarRec.png';
import IQOSVideoBG from '../images/IQOS-VideoBG.png';

import NavBar from "./reusable-components/nav-bar";

function GetNotification() {
    return (
        <div>
            <div>
                <NavBar />
            </div>
            <div>
                {/* <div className="topBar"
                    style={{ paddingRight: '10px' }}>

                    <img src={TopBar} style={{ width: '375px', height: '40px' }} alt="" />
                </div> */}
                <div >
                    <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
                </div>
                <div style={{
                    height: '175px',
                    marginBottom: '20px'
                }}>
                    <img src={IQOSVideoBG} style={{ width: '100%', height: '175px' }} alt="" />
                </div>
                <div>
                    <div style={{
                        fontFamily: 'Sintony',
                        textAlign: 'center',

                        marginLeft: '20px',
                        marginRight: '20px'

                    }}>
                        <span style={{
                            color: '#3786C3',
                            fontSize: '14px',
                            fontWeight: '700',
                            // marginBottom: '20px'
                        }}
                        >GETTING STARTED</span>
                        <p style={{
                            fontSize: '13px',
                            marginTop: '20px'
                        }}>
                            Check out this short video introduction to IQOS and our eight-step program!
                        </p>
                    </div>
                </div>
                <div>
                    <Row>
                        <Col>

                        </Col>
                        <Col >

                        </Col>
                    </Row>
                    <Row>
                        <Col>

                        </Col>
                        <Col >

                        </Col>
                    </Row>
                </div>
                <div style={{
                    font: 'Sintony',
                    fontSize: '14px',
                    lineHeight: '18.24px',
                    color: '#475666',
                    textAlign: 'center',
                    fontWeight: '700',
                    marginBottom: '40px',
                    marginTop: '40px'
                }}>
                    <span>DASHBOARD</span>
                    <Row style={{
                        marginTop: '20px'
                    }}>
                        <Col>MY IQOS</Col>
                        <Col style={{
                            font: 'Sintony',
                            fontSize: '12px',
                            lineHeight: '18.24px',
                            color: '#475666',
                            textAlign: 'center',
                            fontWeight: '400',
                        }}>COMMUNITY</Col>
                    </Row>
                </div>

                {/* Pie chart div Starts */}
                <div>

                </div>
                {/* Pie chart div Ends */}
                <div style={{
                    marginBottom: '50px'
                }}>
                    <Row>
                        <Col style={{
                            textAlign: 'center',
                            font: 'Sintony',
                            fontSize: '13px',
                            lineHeight: '13px',
                            color: '#475666',
                            fontWeight: '400'

                        }}>
                            USAGE
                        </Col>
                        <Col style={{
                            textAlign: 'center',
                            font: 'Sintony',
                            fontSize: '13px',
                            lineHeight: '13px',
                            color: '#475666',
                            fontWeight: '400'

                        }}>
                            MY DEVICE
                        </Col>
                    </Row>
                    <Row style={{
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}>
                        <Col style={{
                            textAlign: 'center'
                        }}>
                            <img src={IQOSUSAGE} style={{ width: '108px', height: '78px' }} alt="" />
                        </Col>
                        <Col style={{
                            textAlign: 'center'
                        }}>
                            <img src={IQOSMyDevice} style={{ width: '108px', height: '100px' }} alt="" />
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{
                            textAlign: 'center',
                            font: 'Sintony',
                            fontSize: '12px',
                            lineHeight: '13px',
                            color: '#475666',
                            fontWeight: '400'

                        }}>
                            IQOS USAGE THIS WEEK

                        </Col>
                        <Col style={{
                            textAlign: 'center',
                            font: 'Sintony',
                            fontSize: '12px',
                            lineHeight: '13px',
                            color: '#475666',
                            fontWeight: '400'

                        }}>
                            DEVICE LIFE
                        </Col>
                    </Row>
                </div>
                {/* Meet IQOS div */}
                <div style={{
                    marginBottom: '30px'
                }}>
                    <div style={{
                        font: 'Sintony',
                        fontSize: '14px',
                        lineHeight: '18.24px',
                        color: '#475666',
                        textAlign: 'center',
                        fontWeight: '700',
                        marginBottom: '40px'
                    }}>
                        <span>MEET IQOS</span>
                    </div>
                    <Row>
                        <Col style={{
                            textAlign: 'center'
                        }}>
                            <img src={IQOSWHITE} style={{ width: '76px', height: '136px' }} alt="" />
                        </Col>

                        <Col style={{
                            textAlign: 'center'
                        }}>
                            <img src={IQOSBLACK} style={{ width: '76px', height: '136px' }} alt="" />
                        </Col>

                        <Col style={{
                            textAlign: 'center'
                        }}>
                            <img src={IQOSCOPPER} style={{ width: '76px', height: '136px' }} alt="" />
                        </Col>
                    </Row>
                    <Row style={{
                        marginTop: '10px',
                        marginBottom: '20px'
                    }}>
                        <Col style={{
                            fontSize: '11px',
                            lineHeight: '15px',
                            textAlign: 'center'
                        }}>
                            IQOS 3 DUO KIT
                            WHITE
                        </Col>

                        <Col style={{
                            fontSize: '11px',
                            lineHeight: '15px',
                            textAlign: 'center'
                        }}>
                            IQOS 3 DUO KIT <br></br>
                            BLACK
                        </Col>

                        <Col style={{
                            fontSize: '11px',
                            lineHeight: '15px',
                            textAlign: 'center'
                        }}>
                            IQOS 3 DUO KIT
                            COPPER
                        </Col>
                    </Row>

                </div>
                <div style={{
                    height: '250px',
                    backgroundImage: `url(${PersonaliseBG})`,
                    backgroundRepeat: 'no-repeat'
                }}>
                    <div style={{

                        textAlign: 'left',

                        color: '#FFFFFF',
                        paddingTop: '85px',
                        paddingLeft: '20px'
                    }}>
                        <div style={{
                            fontSize: '17px',
                            fontWeight: '700',
                            font: 'Sintony'

                        }}>
                            Personalize <br></br>
                            your IQOS
                        </div>
                        <div style={{
                            marginTop: '10px'
                        }}>
                            <Button variant="outline-secondary" size="lg" type="submit" style={{
                                height: '43px',
                                width: '123px',
                                fontSize: '12px',
                                borderRadius: '0',
                                color: '#FFFFFF',
                                borderColor: '#FFFFFF'

                            }} >
                                GET STARTED
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Footer starts here */}
                <div className="footer"
                    style={{
                        padding: '13px',
                        width: '100%',
                        height: '190px',
                        textAlign: 'center',
                        backgroundImage: `url(${RectangleGrey})`
                    }}>

                    <img src={Shape} style={{ width: '65px', height: '17px', marginBottom: '20px' }} alt="" />
                    <div className="row" style={{
                        fontSize: '12px',
                        textAlign: 'left'
                    }}>
                        {/*Col 1 */}
                        <div className="col" style={{
                            fontSize: '12px',
                            lineHeight: '25px',
                            fontWeight: '400'
                        }}>
                            <ul className="list-unstyled">
                                <li>CONTACT US</li>
                                <li>HELP</li>
                                <li>TERMS OF SERVICE</li>
                                <li>PHILIPMORRISUSA.COM</li>
                            </ul>
                        </div>
                        {/*Col 2 */}
                        <div className="col" style={{
                            fontSize: '12px',
                            lineHeight: '25px',
                            fontWeight: '400'
                        }}>
                            <ul className="list-unstyled">
                                <li>SHOP IQOS</li>
                                <li>PRIVACY STATEMENT</li>
                                <li>TOBACCORIGHTS.COM</li>
                                <li>RESPONSIBILITY</li>
                            </ul>
                        </div>

                    </div>
                    <div style={{
                        fontSize: '12px',
                        lineHeight: '25px',
                        fontWeight: '400'
                    }}>
                        <p>© 2020 PHILIP MORRIS USA INC.</p>
                    </div>
                </div>
                {/* Footer ends here */}
            </div >
        </div>
    );
}

export default GetNotification;